var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80 0H0V80H80V0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_409_3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.001 80C62.094 80 80.001 62.091 80.001 40C80.001 17.907 62.094 -0.000976562 40.001 -0.000976562C17.908 -0.000976562 0.000976562 17.908 0.000976562 40C0.000976562 62.092 17.908 80 40.001 80Z",
  fill: "#EAEAEA"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M80 0H0V80H80V0Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_409_3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.678 62.3264C32.685 62.3264 30.247 59.8904 30.247 56.8974C30.247 56.2904 30.74 55.7964 31.349 55.7964C31.956 55.7964 32.451 56.2894 32.451 56.8974C32.451 58.6774 33.899 60.1244 35.678 60.1244C37.456 60.1244 38.905 58.6774 38.905 56.8974V30.3354C38.905 29.7264 39.398 29.2334 40.006 29.2334C40.615 29.2334 41.109 29.7264 41.109 30.3354V56.8964C41.108 59.8894 38.671 62.3264 35.678 62.3264Z",
  fill: "#260046"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M80 0H0V80H80V0Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_409_3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.005 21.9937C39.398 21.9937 38.903 21.5007 38.903 20.8917V16.6977C38.903 16.0907 39.398 15.5967 40.005 15.5967C40.614 15.5967 41.108 16.0897 41.108 16.6977V20.8917C41.108 21.5007 40.614 21.9937 40.005 21.9937Z",
  fill: "#260046"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M80 0H0V80H80V0Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3_409_3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.079 38.9603C23.871 38.9603 26.276 40.4823 27.405 42.6833C28.534 40.4823 30.937 38.9603 33.73 38.9603C36.522 38.9603 38.928 40.4823 40.058 42.6833C41.186 40.4823 43.59 38.9603 46.383 38.9603C49.176 38.9603 51.58 40.4823 52.709 42.6833C53.837 40.4823 56.241 38.9603 59.034 38.9603C61.854 38.9603 64.277 40.5113 65.393 42.7433C65.331 28.7713 53.991 18.2383 40.004 18.2383C25.978 18.2383 14.608 28.8313 14.608 42.8553H14.663C15.752 40.5633 18.213 38.9603 21.079 38.9603Z",
  fill: "#ED4300"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M80 0H0V80H80V0Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask4_409_3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M56.185 26.2764L54.645 21.8614C54.459 21.3064 53.953 20.9004 53.334 20.9004C52.702 20.9004 52.187 21.3304 52.017 21.9074L50.484 26.2764C50.382 26.5804 50.314 26.9014 50.314 27.2404C50.314 28.9094 51.666 30.2634 53.334 30.2634C55.004 30.2634 56.357 28.9094 56.357 27.2404C56.357 26.9014 56.289 26.5814 56.185 26.2764Z",
  fill: "white"
}));

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_409_3"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 80,
  fill: "white"
})));

var SvgUmbrellaCover = function SvgUmbrellaCover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_409_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_409_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _ref2), _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_409_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _ref4), _ref5, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_409_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _ref6), _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_409_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _ref8), _ref9, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_409_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _ref10), _ref11), _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUmbrellaCover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/umbrella-cover.13547905.svg";
export { ForwardRef as ReactComponent };